import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';

const SHOW_WITHIN_DAYS = 14;

/**
 * Countdown banner for team admins during the last days of an Institutional
 * trial. Renders nothing outside a trial, outside the window, after expiry
 * (plan is then 'free'), or for non-admin members.
 */
export default function TrialBanner() {
  const { activeTeam, isActiveTeamAdmin } = useUser();
  // Mount-time snapshot: day-granularity countdown doesn't need re-render
  // ticking, and calling Date.now() during render violates react-hooks/purity.
  const [nowMs] = useState(() => Date.now());

  if (!activeTeam?.plan_expires_at || activeTeam.plan_id === 'free' || !isActiveTeamAdmin) {
    return null;
  }

  const msLeft = new Date(activeTeam.plan_expires_at).getTime() - nowMs;
  if (Number.isNaN(msLeft) || msLeft <= 0) return null;

  const daysLeft = Math.ceil(msLeft / 86_400_000);
  if (daysLeft > SHOW_WITHIN_DAYS) return null;

  return (
    <div className="bg-caution-100 border-b border-stone-200 px-4 py-2 text-sm text-ink-900 flex items-center justify-center gap-3">
      <span>
        Your Institutional trial ends in{' '}
        <span className="font-semibold">{daysLeft} day{daysLeft !== 1 ? 's' : ''}</span>.
      </span>
      <Link to="/profile" className="font-medium text-navy-700 hover:underline">
        Subscribe to keep access
      </Link>
    </div>
  );
}
